// extracted by mini-css-extract-plugin
module.exports = {"carouselContainer":"Carousel_carouselContainer__3JuRj","carouselContent":"Carousel_carouselContent__1I7TJ"};